import { render } from "./tabBar.vue?vue&type=template&id=041ac940&scoped=true&ts=true"
import script from "./tabBar.vue?vue&type=script&lang=ts"
export * from "./tabBar.vue?vue&type=script&lang=ts"

import "./tabBar.vue?vue&type=style&index=0&id=041ac940&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/miyo-prod/ftrc-prd/src/project/fotile-riskctl/code/frontend/mgr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-041ac940"]])

export default __exports__